import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPage } from '../../types/page';

const initialState: IPage = {
  stickyScrollBtnVisible: false,
  mobileFiltersVisible: false,
  modals: {
    newDreamOnboardingModalOpen: false,
    homeProfileOnboardingModalOpen: false,
  },
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    toggleStickyScrollBtn(state, action: PayloadAction<boolean>) {
      state.stickyScrollBtnVisible = action.payload;
    },
    toggleMobileFiltersModal(state, action: PayloadAction<boolean>) {
      state.mobileFiltersVisible = action.payload;
    },
    openNewDreamOnboardingModal(state, action: PayloadAction<boolean>) {
      state.modals.newDreamOnboardingModalOpen = action.payload;
    },
    openHomeProfileOnboardingModal(state, action: PayloadAction<boolean>) {
      state.modals.homeProfileOnboardingModalOpen = action.payload;
    },
  },
});

export const {
  reducer: pageReducer,
  actions: {
    toggleStickyScrollBtn,
    toggleMobileFiltersModal,
    openNewDreamOnboardingModal,
    openHomeProfileOnboardingModal,
  },
} = pageSlice;
